import { render } from "./KskNumericKeypad.vue?vue&type=template&id=215edc0e&scoped=true"
import script from "./KskNumericKeypad.vue?vue&type=script&lang=js"
export * from "./KskNumericKeypad.vue?vue&type=script&lang=js"

import "./KskNumericKeypad.vue?vue&type=style&index=0&id=215edc0e&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215edc0e"]])

export default __exports__